import React, { useRef } from "react"
import { Modal, Typography, Space, Button, message } from "@mimber/ui-web"
import { useDeleteAnnouncement } from "@mimber/client/mimber-organization"
import type { DeleteAnnouncementModalProps } from "./DeleteAnnouncementModal.types"

const { Text, Paragraph } = Typography

export const DeleteAnnouncementModal: React.FunctionComponent<
  DeleteAnnouncementModalProps
> = ({ announcement, onSuccess, ...modalProps }) => {
  const closeRef = useRef<(() => void) | null>(null)

  const mutation = useDeleteAnnouncement(announcement.uuid, {
    onSuccess: () => {
      message.success("Announcement deleted successfully")
      closeRef.current?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to delete announcement: ${error.message}`)
    },
  })

  return (
    <Modal title="Delete Announcement" footer={null} {...modalProps}>
      {(close) => {
        closeRef.current = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Paragraph>
              Are you sure you want to delete this{" "}
              <Text strong>{announcement.priority.toLowerCase()}</Text>{" "}
              announcement?
            </Paragraph>
            <Paragraph type="secondary">
              This action cannot be undone.
            </Paragraph>
            <Space style={{ justifyContent: "flex-end", width: "100%" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate()}
              >
                Delete Announcement
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
